// extracted by mini-css-extract-plugin
export default {"cardsSectionWrapper":"LandingNewPage-module__cardsSectionWrapper__PEb6s"};